import { createElement } from 'react';
import { string } from 'prop-types';
import '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import 'classnames';
import 'reakit/Heading';
import '../Heading/styled.js';
import '../Heading/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import { ToastIconWrapper, ToastIcon as ToastIcon$1 } from './styled.js';

var ToastIcon = function ToastIcon(_ref) {
  var size = _ref.size,
      type = _ref.type,
      props = _objectWithoutPropertiesLoose(_ref, ["size", "type"]);

  return createElement(ToastIconWrapper, props, createElement(ToastIcon$1, {
    "aria-hidden": true,
    a11yLabel: type,
    color: type,
    icon: type,
    size: size
  }));
};
var toastIconPropTypes = {
  size: string,
  type: string.isRequired
};
ToastIcon.propTypes = toastIconPropTypes;
var toastIconDefaultProps = {
  size: undefined
};
ToastIcon.defaultProps = toastIconDefaultProps; // @ts-ignore

var C = ToastIcon;

export default C;
export { ToastIcon, toastIconDefaultProps, toastIconPropTypes };
